// extracted by mini-css-extract-plugin
export default {"outer":"Videos_outer__uLuIV","video_pack":"Videos_video_pack__s47fJ","embed_responsive":"Videos_embed_responsive__8Qiwk"};